import React, { useContext, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { Checkbox, FormControlLabel, RadioGroup } from '@material-ui/core';
import classNames from 'classnames';

import { RootState } from 'src/configs/store';
import './BetslipOptions.scss';
import Icon from 'src/components/Icon/Icon';
import AppModeContext from 'src/containers/AppMode/AppMode.context';

export default function BetslipOptions() {
  const { t } = useTranslation('common');
  const dispatch = useDispatch();
  const [open, setOpen] = useState(false);
  const ref = useRef(null);
  const showProfit = useSelector((state: RootState) => state.betslip.showProfit);
  const acceptOddsChanges = useSelector((state: RootState) => state.betslip.acceptOddsChanges);
  const removeSuspendedMarkets = useSelector((state: RootState) => state.betslip.removeSuspendedMarkets);
  const { RETAIL_MODE } = useContext(AppModeContext);
  const isRetail = RETAIL_MODE;

  const selectedStake = useSelector((state: RootState) => {
    let _slip = 'singleSlip';
    const slip = state.betslip.slip;

    if (slip === 1) {
      _slip = 'accaSlip';
    } else if (slip === 2){
      _slip = 'systemSlip';
    }

    return state.betslip[_slip].stakeSelection;
  });

  const handleShowProfit = () => {
    dispatch.betslip.changeShowProfit();
  };

  const handleOptions = (type) => {
    dispatch.betslip.changeBetsipOptions(type);
  };

  const constantHeight = isRetail ? window.innerHeight - 180 : window.innerHeight - 100;

  return (
    <div className="betslip-options" ref={ ref }>
      <div onClick={ () => setOpen(!open) } className="betslip-options__settings">
        { t('betslip.settings') }
        <Icon
          icon="arrow"
          className={
            classNames(
              'register-bet__arrow',
              { 'register-bet__arrow--open': open }
            )
          }
        />
      </div>
      {
        open && (
          <>
            <div className={
              classNames({
                'betslip-wrapper__options-container': true,
                'betslip-wrapper__options-container--top':  ref.current && ref.current?.getBoundingClientRect().bottom > constantHeight
              })
            }
            >
              <RadioGroup>
                <FormControlLabel
                  className="betslip-wrapper__option"
                  value="any"
                  labelPlacement="start"
                  control={
                    <Checkbox
                      color="default"
                      checked={ acceptOddsChanges }
                      onChange={ () => handleOptions('acceptOddsChanges') }
                    />
                  }
                  label={ t('betslip.acceptAny') }
                />
              </RadioGroup>
              <FormControlLabel
                className="betslip-wrapper__suspended"
                labelPlacement="start"
                control={
                  <Checkbox color="default" checked={ removeSuspendedMarkets } onChange={ () => handleOptions('removeSuspendedMarkets') } />
                }
                label={ t('betslip.removeSuspended') }
              />
              {
                selectedStake !== 'differentStake' &&
                <FormControlLabel
                  className="betslip-wrapper__option"
                  labelPlacement="start"
                  control={
                    <Checkbox color="default" onChange={ handleShowProfit } checked={ showProfit } />
                  }
                  label={ t('betslip.showProfit') }
                />
              }
            </div>
          </>
        )
      }
    </div>
  );
}
